import { Component, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import { DashboardService } from 'src/app/services/dashboard.service';
import { Router } from '@angular/router';
import { DistrictWiseModel } from 'src/app/models/department-app-verification.model';
import saveAs from 'file-saver';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { shareReplay} from 'rxjs/operators';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-district-wise-report',
  templateUrl: './district-wise-report.component.html',
  styleUrls: ['./district-wise-report.component.scss']
})
export class DistrictWiseReportComponent implements OnInit {
  value:any;
  districtWise: any[];
  grandTotalApp:number;
  grandVerfApp:number;
  grandReturnProcessApp:number;
  grandOnTime:number;
  grandPendingByWeek:number;
  grandPendingMoreThanWeek:number;
  grandRegectedApp:number;
  grandMiArea:number;
  grandMiTotalArea:number;
  appVerificationItems: MenuItem[];
  appVerificationModel: DistrictWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  public subscriptions: any = [];
  public loading: boolean = false;
  userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  displayMaximizable_pendingApp:boolean;
  drilldownDetails:any;
  pendingType:any;
  displayMaximizable_rejectedApp:any;
  name:any;
  routePath:any;
  subjectSub:any;
  selectedYear:any
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    this.routePath=router.split('/')
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "District_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "District_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }

  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getAppVerification_DistrictWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.districtWise = data;
              this.appVerificationModel = data;
              this. calculateGrandTotal();
             
            }
            else{
              this.districtWise = [];
              this.appVerificationModel = [];
              this. calculateGrandTotal();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "District" : d.District,
          "Total Application": d.TotalApplication,
          "Verified Application": d.VerifiedApplication,
          "Return Process Application": d.ReturnProcessApplication,
          "On Time": d.PendingEarly,
          "Pending by one Week": d.Pending_1Week,
          "Pending more than one Week": d.Pending_Morethan_1Weeks,
          "Rejected Application": d.RejectedApplication,
          "Verified MI Area":d.MIArea,
          "MI Total Area":d.MITotalArea,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'District', header: 'District'},
      { field: 'TotalApplication', header: 'Total Application' },
      { field: 'VerifiedApplication', header: 'Verified Application' },
      { field: 'ReturnProcessApplication', header: 'Return Process Application' },
      { field: 'PendingEarly', header: 'On Time' },
      { field: 'Pending_1Week', header: 'Pending by one Week' },
      { field: 'Pending_Morethan_1Weeks', header: 'Pending More than one Weeks' },
      { field: 'RejectedApplication', header: 'Rejected Application' },
      { field: 'MIArea', header: 'Verified MI Area' },
      { field: 'MITotalArea', header: 'MI Total Area' },

     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  // selectFarmerApplication(application) {
  //   if(application.Scheme_Specific_Id){
  //     this.dashboard
  //     .getMIDetailByAppID(application.Scheme_Specific_Id)
  //     .pipe(first())
  //     .subscribe({
  //       next: (res) => {
  //         const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
  //         window.open(link, '_blank');
  //       },
  //       error: (err) => {
  //         console.log("error", err);
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });
  //   }
  //    else {
  //     this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
  //   }
  // }
  // onRowSelect(event) {
  //   this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Selected',
  //     detail: event.data.name,
  //   });
  // }
  // onRowUnselect(event) {
  //   this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Unselected',
  //     detail: event.data.name,
  //   });
  // }
  // calculation(){
  //   this.filteredData = [];
  //   // this.filteredDataForExport = event.filteredValue;
  //   this.totalSelectedApp = 0;
  //   this.totalSubToFarmer = 0;
  //   this.totalSubToVendor = 0;
  //   this.totalFarmerRefund = 0;
    
  //   this.totalSelectedApp = this.filteredDataForExport.length;
  //   this.filteredDataForExport.forEach((val) => {
  //     this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
  //     this.totalSubToVendor += val.SubsidyToVendor_Amount;
  //     this.totalFarmerRefund += val.FarmerRefund_Amount;
  //   })
  //   this.filteredDataForExport.forEach(val => {
  //     this.filteredData.push(
  //       {
  //         appID: val.Scheme_Specific_Id, 
  //         programID: val.ProgramID,
  //         subsidy_Amt: 0,  
  //         amt_Disbus_to_Vendor: 0, 
  //         amt_Refund_to_Farmer: 0, 
  //         farmerShareToVendor: val.Farmer_Share_To_Vendor, 
  //         state_share_amt: val.State_Share_Payment_Amount, 
  //         centre_share_amt: val.Center_Share_Payment_Amount, 
  //     }) 
  //   })
  // }
  calculateGrandTotal(){
    this.grandTotalApp=0;
    this.grandVerfApp=0;
    this.grandReturnProcessApp=0;
    this.grandOnTime=0;
    this.grandPendingByWeek=0;
    this.grandPendingMoreThanWeek=0;
    this.grandRegectedApp=0;
    this.grandMiArea=0;
    this.grandMiTotalArea=0;
    for(let districtWiseData of this.districtWise) {
      this.grandTotalApp += districtWiseData.TotalApplication;
      this.grandVerfApp += districtWiseData.VerifiedApplication;
      this.grandReturnProcessApp += districtWiseData.ReturnProcessApplication;
      this.grandOnTime += districtWiseData.PendingEarly;
      this.grandPendingByWeek += districtWiseData.Pending_1Week;
      this.grandPendingMoreThanWeek += districtWiseData.Pending_Morethan_1Weeks;
      this.grandRegectedApp += districtWiseData.RejectedApplication;
      this.grandMiArea += districtWiseData.MIArea;
      this.grandMiTotalArea += districtWiseData.MITotalArea;
  }
  }
  showMaximizableDialog(value:any,status:any) {
      
      this.name=status;
    this.value=value;
    this.drilldownDetails={
      actionType:"AppVerification",
      
      filterType:"District",
      value:this.value,
      status:status,
      MIType:""
    }
    
    this.displayMaximizable = true;
    // console.log(this.value,"value")
    // console.log(this.drilldownDetails,"this.drilldownDetails")

} 
showMaximizableDialog_totalApp(value:any) {
      
      
  this.value=value;
  this.drilldownDetails={
    actionType:"AppVerification",
    
    filterType:"District",
    value:this.value,
    MIType:""
  }
  
  this.displayMaximizable_totalApp = true;

  // console.log(this.value,"value")
  // console.log(this.drilldownDetails,"this.drilldownDetails")

}
showMaximizableDialog_pending(value:any,duration:any) {
      
  if(duration=='early'){
    this.pendingType='On Time'
  }
  if(duration=='1Week'){
    this.pendingType='Pending by Week'
  }
  if(duration=='morethan_1Week'){
    this.pendingType='Pending more than one Week' 
  }
  this.value=value;
  this.drilldownDetails={
    actionType:"AppVerification",
    
    filterType:"District",
    value:this.value,
    duration:duration,
    MIType:""
  }
  
  this.displayMaximizable_pendingApp = true;
  // console.log(this.value,"value")
  // console.log(this.drilldownDetails,"this.drilldownDetails")

}
showMaximizableDialog_rejected(value:any) {
      
      
  this.value=value;
  this.drilldownDetails={
    actionType:"AppVerification",
    
    filterType:"District",
    value:this.value,
    MIType:""
  }
  
  this.displayMaximizable_rejectedApp = true;
  
  // console.log(this.value,"value")
  // console.log(this.drilldownDetails,"this.drilldownDetails")

}

}
